import { SCHEDULING_METHOD_VARIANT_LABELS } from "../constants/schedulingMethods";
import { SchedulingMethod } from "../types/schedulingMethods";
import { formatPhoneNumber } from "./formatPhoneNumber";

type PhoneNumberPart = keyof NonNullable<SchedulingMethod["phone_number"]>;

export const formatPhoneNumberMethod = (
  schedulingMethod?: SchedulingMethod["phone_number"],
  parts: PhoneNumberPart[] = ["number", "ext", "variant"],
) => {
  if (!schedulingMethod) return "";

  const { number: _number, ext: _ext, variant: _variant } = schedulingMethod;
  const number = _number?.trim();

  if (!number) return "";

  const ext = _ext?.trim();
  const variant = _variant && SCHEDULING_METHOD_VARIANT_LABELS[_variant];

  const include = new Set(parts);

  return [
    include.has("number") ? formatPhoneNumber(number) : null,
    include.has("ext") && ext ? `ext. ${ext}` : null,
    include.has("variant") && variant ? `- ${variant}` : null,
  ]
    .filter(Boolean)
    .join(" ");
};
